// extracted by extract-css-chunks-webpack-plugin
module.exports = {"swiper":"swiper_8oQjW","fadeInImg":"fadeInImg_Ej5GG"};